import loadable from "@loadable/component"
import { RouteObject } from "react-router-dom"

const LoadingManagementLayout = loadable(
  async () => import("~/features/loading/pages/LoadingManagementLayout"),
  { fallback: <></> },
)
const LoadingManagementPage = loadable(
  async () => import("~/features/loading/pages/LoadingManagementPage"),
  { fallback: <></> },
)

export const loadingRoutes: RouteObject[] = [
  {
    path: "loading-management",
    element: <LoadingManagementLayout />,
    children: [{ index: true, element: <LoadingManagementPage /> }],
  },
]
